<main>
	<div class="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
		<ng-content />
	</div>
</main>
